import { ShieldTaskRegular, BranchForkRegular, TagRegular } from '@fluentui/react-icons'
import { CapabilityCard } from '@/components/common/CapabilityCard'
import { PanelShell } from './PanelShell'
import grid from './PanelGrid.module.css'

interface PanelProps {
  onOpenWorkspace: () => void
}

export function IncidentsPanel({ onOpenWorkspace }: PanelProps) {
  return (
    <PanelShell
      icon={ShieldTaskRegular}
      title="Incidents"
      subtitle="Cross-domain incident investigation and correlation across Microsoft Sentinel and Defender XDR."
      onOpenWorkspace={onOpenWorkspace}
    >
      <div className={grid.grid}>
        <CapabilityCard
          icon={ShieldTaskRegular}
          eyebrow="Resolution"
          title="Incident resolution"
          points={['Sentinel / Defender XDR incident resolution', 'Incident alerts', 'Incident entities']}
        />
        <CapabilityCard
          icon={TagRegular}
          eyebrow="Context"
          title="Tactics & techniques"
          points={['MITRE ATT&CK tactic and technique mapping surfaced from incident alerts']}
        />
        <CapabilityCard
          icon={BranchForkRegular}
          eyebrow="Routing"
          title="Downstream investigation"
          points={[
            'Routes findings toward identity and endpoint investigation when entities warrant it',
          ]}
        />
      </div>
    </PanelShell>
  )
}
